export function updateAt<T>(
    state: { [stateKey: string]: T | undefined },
    stateKey: string,
    update: (value: T | undefined) => T | undefined
): { [stateKey: string]: T | undefined } {
    return {
        ...state,
        [stateKey]: update(state[stateKey])
    }
}
